import { render, staticRenderFns } from "./ProfitDisplay.vue?vue&type=template&id=a08f58ce&scoped=true&"
import script from "./ProfitDisplay.vue?vue&type=script&lang=js&"
export * from "./ProfitDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ProfitDisplay.vue?vue&type=style&index=0&id=a08f58ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08f58ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
